// Sidebar entries owned by the Oncall module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { oncallPaths } from './paths'

export const oncallNav = {
    dashboard: {
        title: 'oncall:oncall_dashboard',
        path: oncallPaths.oncall,
    },
    schedules: {
        title: 'oncall:oncall_schedules',
        path: oncallPaths.oncallSchedules,
    },
    assignments: {
        title: 'oncall:oncall_assignments',
        path: oncallPaths.oncallAssignments,
    },
    swaps: {
        title: 'oncall:oncall_swaps',
        path: oncallPaths.oncallSwaps,
    },
    compensations: {
        title: 'oncall:oncall_compensations',
        path: oncallPaths.oncallCompensations,
    },
} satisfies Record<string, SidebarType>
